import React from "react";
import TopHeader from "../../Components/TopHeader";
import EmailSubscription from "../../Components/EmailSubscription";
import Footer from "../../Components/Footer";
import { Link } from "react-router-dom";
const CookiePolicy = () => {
    return (

        <>
        <TopHeader />

        <div
  className="col-lg-8 mx-auto protected-content main-container no-overflow-x pt-0 terms-wrapper cookie-policy-section"
  draggable="false"
>
  <h1 className="my-5">
    Cookie Policy
  </h1>
  <article className="text-justify protected-content">
    <div className="c29 c58">
      <p className="c52">
        <span className="c32 c38">
          Last Updated: October 2021
        </span>
      </p>
      <p className="c20">
        <span className="c17">
          INFORMATION ABOUT OUR USE OF COOKIES
        </span>
        <span className="c11">
        </span>
      </p>
      <p className="c20">
        <span className="c11">
        </span>
      </p>
      <p
        className="c20"
        id="h.gjdgxs"
      >
        The CIRCULAR COUTURE website{' '}
        <span className="c54">
          <Link
            className="c16"
            to="/Home"
            target="_blank"
          >
            https://www.circularcouture.com
          </Link>
        </span>
        <span className="c19">
          {' '}(the            "
          <strong>
            Site
          </strong>
          ") uses cookies to distinguish you from other users of the Site. This helps us to            provide you with a good experience when you browse the Site. We do this by analysing how easy it is to use            the Site, by identifying potential bottlenecks in the experience and monitoring performance so that your            usage of the Site goes largely uninterrupted.
        </span>
      </p>
      <p className="c8">
        <span className="c11" />
      </p>
      <p className="c20">
        <span className="c19">
          A cookie is a small file comprised of letters and numbers that we store on your            browser or the hard drive of your computer if you agree. Cookies contain information that is transferred to            your computer’s hard drive.
        </span>
      </p>
      <p className="c20">
        <span className="c11">
        </span>
      </p>
      <p className="c20">
        <span className="c11">
          We use the following cookies:
        </span>
      </p>
      <p className="c20">
        <span className="c11">
        </span>
      </p>
      <ol
        className="c0 lst-kix_list_3-0 start"
        start="1"
      >
        <li className="c36">
          <span className="c17">
            {' '}Strictly necessary cookies.
          </span>
          <span className="c11">
            {' '}These are cookies that              are required for the operation of the Site. They include, for example, cookies that enable you to log into              secure areas of the Site, use a shopping cart or make use of e-billing services.
          </span>
        </li>
        <li className="c36">
          <span className="c17">
            {' '}Analytical/performance cookies.
          </span>
          <span className="c11">
            {' '}These allow us to              recognise and count the number of visitors and to see how visitors move around the Site when they are              using it. This helps us to improve the way the Site works, for example, by ensuring that users are finding              what they are looking for easily.
          </span>
        </li>
        <li className="c36">
          <span className="c17">
            {' '}Functionality cookies.
          </span>
          <span className="c11">
            {' '}These are used to recognise              you when you return to our Site. This enables us to personalise our content for you, greet you by name and              remember your preferences (for example, your choice of language or region).
          </span>
        </li>
        <li className="c36">
          <span className="c17">
            {' '}Targeting cookies.
          </span>
          <span className="c11">
            {' '}These cookies record your visit              to our Site, the pages you have visited and the links you have followed. We will use this information to              make our Site and the advertising displayed on it more relevant to your interests. We also share this              information with third parties for this purpose.
          </span>
        </li>
      </ol>
      <p className="c21 c29">
        <span className="c19">
          You can find more information about the individual cookies we use and the            purposes for which we use them in the below table:
        </span>
      </p>
      <Link id="t.f0d77681e6477e8474738e17e05380613d539eb2" />
      <Link id="t.0" />
      <table className="c45">
        <tbody>
          <tr className="c35">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c56">
                <span className="c6">
                  Cookie Type
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c44">
                <span className="c6">
                  Supplier
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c44">
                <span className="c6">
                  Purpose
                </span>
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c44">
                <span className="c6">
                  More information
                </span>
              </p>
            </td>
          </tr>
          <tr className="c31">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c32 c17">
                  Strictly necessary cookies
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c22">
                  CIRCULAR COUTURE
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c11">
                  This cookie enables us to remember users that are logged into our                    website and keep them logged in for a convenient user experience.
                </span>
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span>
                  N/A
                </span>
              </p>
            </td>
          </tr>
          <tr className="c31">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c32 c17">
                  Strictly necessary cookies
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c22">
                  Stripe
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c11">
                  Stripe uses a cookie to remember who you are and to enable the website                    to process payments without storing any credit card information on its own servers.
                </span>
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span>
                  You can read more about Stripe's cookies{' '}
                </span>
                <span className="c43">
                  <Link
                    className="c16"
                    to="https://stripe.com/cookies-policy/legal"
                    target="_blank"
                  >
                    here
                  </Link>
                </span>
                <span>
                  .
                </span>
              </p>
            </td>
          </tr>
          <tr className="c31">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c32 c17">
                  Strictly necessary cookies
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c22">
                  Google Tag Manager
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c11">
                  This cookie helps us to deliver other cookies to user devices.
                </span>
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span>
                  You can find out more about Google Tag Manager{' '}
                </span>
                <span className="c43">
                  <Link
                    className="c16"
                    to="https://www.google.co.uk/analytics/tag-manager/use-policy/"
                    target="_blank"
                  >
                    here
                  </Link>
                </span>
                <span>
                  .
                </span>
              </p>
            </td>
          </tr>
          <tr className="c31">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c32 c17">
                  Targeting & Analytical/performance Cookies
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c22">
                  Klaviyo
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c11">
                  Klaviyo uses cookies as a part of our web tracking model to gather                    information to improve conversion rates and email performance.
                </span>
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span>
                  You can find out more about Klaviyo{' '}
                </span>
                <span className="c43">
                  <Link
                    className="c16"
                    to="https://help.klaviyo.com/hc/en-us/articles/360034666712-About-Cookies-in-Klaviyo"
                    target="_blank"
                  >
                    here
                  </Link>
                </span>
                <span>
                  .
                </span>
              </p>
            </td>
          </tr>
          <tr className="c31">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c32 c17">
                  Targeting & Analytical/performance Cookies
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c22">
                  Zendesk
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c11">
                  Anonymous visitor identifier cookies and unique browser session cookies                    enable Zendesk to track guests and users across our website.
                </span>
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span>
                  You can read more about Zendesk’s cookies{' '}
                </span>
                <span className="c43">
                  <Link
                    className="c16"
                    to="https://www.zendesk.co.uk/company/agreements-and-terms/cookie-policy/"
                    target="_blank"
                  >
                    here
                  </Link>
                </span>
                <span>
                  .
                </span>
              </p>
            </td>
          </tr>
          <tr className="c31">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c17">
                  Analytical/ performance{' '}
                </span>
                <span className="c57">
                  C
                </span>
                <span className="c17">
                  ookies
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c33">
                  Google Analytics
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c12">
                <span className="c11 c29">
                  This cookie enables us to:
                </span>
              </p>
              <p className="c12">
                <span className="c11 c29">
                  (a) Estimate our audience size and usage pattern.
                </span>
              </p>
              <p className="c12">
                <span className="c11 c29">
                  (b) Understand how visitors navigate to and through the Site.
                </span>
              </p>
              <p className="c12">
                <span className="c11 c29">
                  (c) Track the effectiveness of digital marketing campaigns.{' '}
                </span>
              </p>
              <p className="c12">
                <span className="c19 c29">
                  (d) Recognise you when you return to our site.
                </span>
              </p>
              <p className="c25 c34">
                <span className="c22" />
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c28">
                  You can find out more about Google Analytics{' '}
                </span>
                <span className="c47">
                  <Link
                    className="c16"
                    to="https://www.google.com/analytics"
                    target="_blank"
                  >
                    here
                  </Link>
                </span>
                <span className="c32 c28 c42">
                  .
                </span>
              </p>
              <p className="c25 c34">
                <span className="c22" />
              </p>
            </td>
          </tr>
          <tr className="c31">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c32 c17">
                  Analytical/performance Cookies
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c21">
                <span className="c11">
                  Heap Analytics
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c11">
                  Heap uses cookies to track how users interact with our website to                    provide statistical insights and user flows.
                </span>
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span>
                  You can read more about Heap's cookies{' '}
                </span>
                <span className="c43">
                  <Link
                    className="c16"
                    to="https://heap.io/privacy"
                    target="_blank"
                  >
                    here
                  </Link>
                </span>
                <span className="c11">
                  .
                </span>
              </p>
            </td>
          </tr>
          <tr className="c31">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c32 c17">
                  Analytical/performance Cookies
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c21">
                <span className="c11">
                  Hotjar
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c11">
                  This cookie is set when the customer first lands on a page with the                    Hotjar script. This ensures that behaviour in subsequent visits to the same site will be attributed                    to the same user ID.
                </span>
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span>
                  You can read more about Hotjar’s cookies{' '}
                </span>
                <span className="c43">
                  <Link
                    className="c16"
                    to="https://help.hotjar.com/hc/en-us/articles/115011789248-Hotjar-Cookies"
                    target="_blank"
                  >
                    here
                  </Link>
                </span>
                <span className="c11">
                  .
                </span>
              </p>
            </td>
          </tr>
          <tr className="c31">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c32 c17">
                  Analytical/performance cookies
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c21">
                <span className="c11">
                  Cloudflare
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c11">
                  This cookie is used to override any security restrictions based on the                    IP address the visitor is coming from. It does not contain any user identification                    information.
                </span>
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span>
                  You can read more about Cloudflare’s cookies{' '}
                </span>
                <span className="c43">
                  <Link
                    className="c16"
                    to="https://support.cloudflare.com/hc/en-us/articles/200170156-Understanding-the-Cloudflare-Cookies"
                    target="_blank"
                  >
                    here
                  </Link>
                </span>
                <span className="c11">
                  .
                </span>
              </p>
            </td>
          </tr>
          <tr className="c53">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c6">
                  Targeting Cookies
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c21">
                <span className="c22">
                  Google Adwords Conversion Tracking
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c32 c28 c42">
                  This cookie helps us deliver targeted online adverts based on                    past visits to the Site.
                </span>
              </p>
              <p className="c5">
                <span className="c22" />
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c28">
                  These cookies expire within 30 days and do not contain information that                    can identify you personally. Please refer to the 
                </span>
                <span className="c27">
                  <Link
                    className="c16"
                    to="https://www.google.com/privacy/ads/"
                    target="_blank"
                  >
                    Google Advertising Privacy                      Notice
                  </Link>
                </span>
                <span className="c28">
                   and{' '}
                </span>
                <span className="c47">
                  <Link
                    className="c16"
                    to="https://policies.google.com/privacy"
                    target="_blank"
                  >
                    Google Privacy Policy
                  </Link>
                </span>
                <span className="c28">
                   for more information.
                </span>
              </p>
            </td>
          </tr>
          <tr className="c10">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c6">
                  Targeting Cookies
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c21">
                <span className="c22">
                  Google Adwords Remarketing
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c28">
                  This cookie helps us deliver targeted online adverts based on past                    visits to the Site.
                </span>
                <span className="c22">
                </span>
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c28">
                  Please refer to the 
                </span>
                <span className="c27">
                  <Link
                    className="c16"
                    to="https://www.google.com/privacy/ads/"
                    target="_blank"
                  >
                    Google Advertising Privacy                      Notice
                  </Link>
                </span>
                <span className="c28">
                   for more information about the ability to opt out and
                </span>
                <span className="c47">
                  <Link
                    className="c16"
                    to="https://policies.google.com/privacy"
                    target="_blank"
                  >
                    Google Privacy Policy
                  </Link>
                </span>
                <span className="c32 c28 c42">
                  .
                </span>
              </p>
              <p className="c25 c34">
                <span className="c22" />
              </p>
            </td>
          </tr>
          <tr className="c10">
            <td
              className="c24"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c25">
                <span className="c32 c17">
                  Targeting Cookies{' '}
                </span>
              </p>
            </td>
            <td
              className="c9"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c21">
                <span className="c11">
                  Facebook Advertising{' '}
                </span>
              </p>
            </td>
            <td
              className="c15"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c11">
                  This cookie helps us deliver targeted online adverts based on visits to                    the Site.
                </span>
              </p>
            </td>
            <td
              className="c18"
              colSpan="1"
              rowSpan="1"
            >
              <p className="c3">
                <span className="c19">
                  Please refer to the{' '}
                </span>
                <span className="c47">
                  <Link
                    className="c16"
                    to="https://www.facebook.com/policies/cookies/"
                    target="_blank"
                  >
                    Facebook Cookie                      Policy
                  </Link>
                </span>
                <span className="c19">
                   for more information
                </span>
                <span>
                  .{' '}
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p className="c21 c29 c34">
        <span className="c11" />
      </p>
      <p className="c21 c29">
        <span className="c19">
          Except for strictly necessary cookies, all cookies will expire after a            certain period. You can see these periods by browsing our cookie preference centre available in the footer            of the website.
        </span>
      </p>
      <hr
        style={{
          display: 'none',
          pageBreakBefore: 'always'
        }}
       />
      <p className="c39">
        <span className="c1">
          MANAGING COOKIES:
        </span>
      </p>
      <p className="c40">
        <span className="c13">
          The most popular web browsers all allow you to manage cookies. You can choose            to accept or reject all cookies, or just specific types of cookies.
        </span>
      </p>
      <p className="c14">
        <span className="c11" />
      </p>
      <p className="c40">
        <span className="c13">
          However, if you use your browser settings to block all cookies (including            strictly necessary cookies) you may not be able to access all or parts of our Site.
        </span>
      </p>
      <p className="c14">
        <span className="c11" />
      </p>
      <p className="c21 c29">
        <span className="c30">
          The following links provide information on how to modify the cookies            settings on some popular browsers:
        </span>
        <span className="c22">
        </span>
      </p>
      <ul className="c0 lst-kix_list_2-0 start">
        <li className="c4">
          <span className="c26">
            <Link
              className="c16"
              to="https://support.google.com/accounts/answer/61416?co%2525253DGENIE.Platform%252525253DDesktop%25252526hl%2525253Den"
              target="_blank"
            >
              Google                Chrome
            </Link>
          </span>
        </li>
        <li className="c4">
          <span className="c26">
            <Link
              className="c16"
              to="https://support.microsoft.com/en-us/windows/microsoft-edge-browsing-data-and-privacy-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd"
              target="_blank"
            >
              Microsoft                Edge
            </Link>
          </span>
        </li>
        <li className="c4">
          <span className="c26">
            <Link
              className="c16"
              to="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectslug=enable-and-disable-cookies-website-preferences&redirectlocale=en-US"
              target="_blank"
            >
              Mozilla                Firefox
            </Link>
          </span>
        </li>
        <li className="c4">
          <span className="c26">
            <Link
              className="c16"
              to="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
              target="_blank"
            >
              Microsoft                Internet Explorer
            </Link>
          </span>
        </li>
        <li className="c4">
          <span className="c26">
            <Link
              className="c16"
              to="https://help.opera.com/en/latest/web-preferences/"
              target="_blank"
            >
              Opera
            </Link>
          </span>
        </li>
        <li className="c4">
          <span className="c26">
            <Link
              className="c16"
              to="https://support.apple.com/en-gb/guide/safari/sfri11471/mac"
              target="_blank"
            >
              Apple Safari
            </Link>
          </span>
        </li>
      </ul>
      <p className="c7">
        <span className="c22" />
      </p>
      <p className="c40">
        <span className="c13">
          Please note that we do not currently respond to Do Not Track (DNT)            signals.
        </span>
      </p>
      <p className="c7">
        <span className="c32 c17" />
      </p>
      <p className="c25 c29">
        <span className="c33">
          You can also visit the{' '}
        </span>
        <span className="c26">
          <Link
            className="c16"
            to="http://www.aboutcookies.org/"
            target="_blank"
          >
            About Cookies
          </Link>
        </span>
        <span className="c22">
          , for            more information about cookies and how to manage them.
        </span>
      </p>
      <p className="c7">
        <span className="c32 c17" />
      </p>
      <p className="c25 c29">
        <span className="c32 c17">
          THIRD PARTY COOKIES:
        </span>
      </p>
      <p className="c25 c29">
        <span className="c11">
          Please note that the following third parties may also use cookies, over            which we have no control. These named third parties may include, for example, advertising networks and            providers of external services like web traffic analysis services. These third party cookies are likely to            be analytical cookies or performance cookies or targeting cookies:
        </span>
      </p>
      <p className="c7">
        <span className="c32 c17" />
      </p>
      <ul className="c0 lst-kix_list_2-0 start">
        <li className="c4">
          <span className="c11">
            Google
          </span>
        </li>
        <li className="c4">
          <span className="c11">
            Facebook
          </span>
        </li>
        <li className="c4">
          <span className="c11">
            Zendesk
          </span>
        </li>
        <li className="c4">
          <span className="c11">
            Klaviyo
          </span>
        </li>
        <li className="c4">
          <span className="c11">
            Cloudflare
          </span>
        </li>
        <li className="c4">
          <span className="c11">
            Heap
          </span>
        </li>
        <li className="c4">
          <span className="c11">
            Hotjar
          </span>
        </li>
      </ul>
      <p className="c20">
        <span className="c11">
        </span>
      </p>
      <p className="c20">
        <span className="c11">
          To deactivate the use of third party advertising cookies, you may use our            cookie consent management solution accessible from the footer of our Site.
        </span>
      </p>
      <p className="c8">
        <span className="c11" />
      </p>
      <p className="c25 c29">
        <span className="c33">
          If you would like more information about these third-party cookies, it is            available from{' '}
        </span>
        <span className="c43">
          <Link
            className="c16"
            to="https://www.youronlinechoices.com/uk/"
            target="_blank"
          >
            YourOnlineChoices.uk
          </Link>
        </span>
        <span className="c22">
          .
        </span>
      </p>
      <p className="c21 c29">
        <span className="c22">
          Note that when third parties are collecting information about you, these            third parties are acting as controllers in their own right (i.e. they are not acting on our behalf).
        </span>
      </p>
      <hr
        style={{
          display: 'none',
          pageBreakBefore: 'always'
        }}
       />
      <p className="c29 c46">
        <span className="c6">
          EMBEDDED CONTENT:
        </span>
      </p>
      <p className="c25 c29">
        <span className="c33">
          Sometimes, we embed images or videos from sites such as YouTube. As a            result, when you visit a page featuring such content, you may be presented with cookies from these websites.            We do not control these cookies and cannot prevent these sites or domains from collecting information on            your use of this content.
        </span>
      </p>
      <p className="c39 c29">
        <span className="c22">
          You should check the relevant third-party website for more information            about them and how to opt out. They may still gather usage information about you (e.g. number of views,            plays, loads etc.) and may also be able to work out who you are even if you are not logged in to their            services.
        </span>
      </p>
      <p className="c21 c29">
        <span className="c33">
          Read more about 
        </span>
        <span className="c26">
          <Link
            className="c16"
            to="https://support.google.com/youtube/answer/171780?hl%253Den-GB"
            target="_blank"
          >
            YouTube's privacy              policy for embedded content
          </Link>
        </span>
        <span className="c22">
          .
        </span>
      </p>
      <p className="c46 c29">
        <span className="c6">
          SOCIAL NETWORKING AND SHARING TOOLS:
        </span>
      </p>
      <p className="c39 c29">
        <span className="c22">
          On some pages, we also feature embedded 'Share' buttons or widgets that            enable you to share content with friends through a number of popular social networking sites (Eg. Twitter;            Facebook; Instagram, etc.).
        </span>
      </p>
      <p className="c21 c29">
        <span className="c22">
          These sites may set cookies which can identify you as an individual when            you are also logged in to their services and even when you are not logged in to their service. This means            they may be collecting information about what you are doing all around the internet, including on the Site.            We do not control these cookies and you should check the relevant third-party site to see how your            information is used and how to opt out.
        </span>
      </p>
      <p className="c39 c29">
        <span className="c32 c1">
          CHANGES TO THIS COOKIE POLICY:
        </span>
      </p>
      <p className="c21 c29">
        <span className="c30">
          We will review, and where necessary update, this policy. If we have your            e-mail address, we may also e-mail you with information on those changes. If we need to, we will also ask            you to confirm that you are happy with those changes.
          <br />
        </span>
      </p>
      <p className="c21 c29">
        <span className="c32 c38">
          Last Updated: October 2021
        </span>
      </p>
      <div>
        <p className="c34 c37">
          <span className="c11" />
        </p>
        <p className="c34 c49">
          <span className="c19 c42 c50" />
        </p>
      </div>
    </div>
  </article>
 
</div>

        <EmailSubscription />
        <Footer />
        </>
    )
}

export default CookiePolicy;